export default "__VITE_ASSET__CQtQnwXb__"